import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { withLatestFrom, switchMap, map, catchError } from 'rxjs/operators';
import { OrderHistoryService } from '../services/orderhistory.service';
import { ProductService } from '../../catalog/services/product-service';
import * as orderhistory from '../actions/order-history.actions';
import * as fromAuth from '../../auth/reducers';
import * as fromOrderHistory from '../reducers';
var OrderHistoryEffects = /** @class */ (function () {
    function OrderHistoryEffects(actions$, store, orderHistorySvc, productsSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.orderHistorySvc = orderHistorySvc;
        this.productsSvc = productsSvc;
        this.loadOrderHistory$ = this.actions$.ofType(orderhistory.OrderHistoryActionTypes.LoadOrderHistory)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), function (action, customerId) { return ({ customerId: customerId }); }), switchMap(function (data) {
            return _this.orderHistorySvc
                .getOrderHeaders(data.customerId)
                .pipe(map(function (response) { return new orderhistory.LoadOrderHistorySuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadOrderHistoryFailed(e)); }));
        }));
        this.expandOrderHistory$ = this.actions$.ofType(orderhistory.OrderHistoryActionTypes.LoadOrderHistoryExpand)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromOrderHistory.getOrderHistoryNextPage)), function (action, customerId, nextPage) { return ({ customerId: customerId, nextPage: nextPage }); }), switchMap(function (data) {
            return _this.orderHistorySvc
                .getOrderHeaders(data.customerId, null, data.nextPage)
                .pipe(map(function (response) { return new orderhistory.LoadOrderHistoryExpandSuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadOrderHistoryExpandFailed(e)); }));
        }));
        this.loadOrderHistoryLines$ = this.actions$.ofType(orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLines)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromOrderHistory.getSelectedOrdernumber)), function (action, customerId, ordernumber) { return ({ customerId: customerId, ordernumber: ordernumber }); }), switchMap(function (data) {
            if (isNaN(data.ordernumber)) {
                return of(new orderhistory.LoadOrderHistoryLinesFailed('Invalid ordernumber'));
            }
            return _this.orderHistorySvc
                .getOrderLines(data.customerId, data.ordernumber)
                .pipe(map(function (response) { return new orderhistory.LoadOrderHistoryLinesSuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadOrderHistoryLinesFailed(e)); }));
        }));
        this.loadOrderHistoryLinesExpand$ = this.actions$.ofType(orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesExpand)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromOrderHistory.getSelectedOrdernumber)), this.store.pipe(select(fromOrderHistory.getOrderHistoryLinesNextPage)), function (action, customerId, ordernumber, nextPage) { return ({ customerId: customerId, ordernumber: ordernumber, nextPage: nextPage }); }), switchMap(function (data) {
            return _this.orderHistorySvc
                .getOrderLines(data.customerId, data.ordernumber, data.nextPage)
                .pipe(map(function (response) { return new orderhistory.LoadOrderHistoryLinesExpandSuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadOrderHistoryLinesExpandFailed(e)); }));
        }));
        this.loadOrderHistoryItem$ = this.actions$.ofType(orderhistory.OrderHistoryActionTypes.LoadOrderHistoryItem)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromOrderHistory.getSelectedOrdernumber)), function (action, customerId, ordernumber) { return ({ customerId: customerId, ordernumber: ordernumber }); }), switchMap(function (data) {
            return _this.orderHistorySvc
                .getOrderHeader(data.customerId, data.ordernumber)
                .pipe(map(function (response) { return new orderhistory.LoadOrderHistoryItemSuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadOrderHistoryItemFailed(e)); }));
        }));
        this.loadReOrderableItems$ = this.actions$.pipe(ofType(orderhistory.OrderHistoryActionTypes.LoadReOrderableItems), withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromOrderHistory.getSelectedOrdernumber)), function (action, customerId, ordernumber) { return ({ customerId: customerId, ordernumber: ordernumber }); }), switchMap(function (data) {
            return _this.productsSvc.findProducts(data.customerId, null, null, null, null, null, null, "order_" + data.ordernumber, true)
                .pipe(map(function (response) { return new orderhistory.LoadReOrderableItemsSuccess(response); }), catchError(function (e) { return of(new orderhistory.LoadReOrderableItemsFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "loadOrderHistory$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "expandOrderHistory$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "loadOrderHistoryLines$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "loadOrderHistoryLinesExpand$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "loadOrderHistoryItem$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderHistoryEffects.prototype, "loadReOrderableItems$", void 0);
    return OrderHistoryEffects;
}());
export { OrderHistoryEffects };
